import {Component} from '@angular/core';

@Component({
    selector: 'svg-checked',
    template: `
        <svg class="svg-checked" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
             viewBox="0 0 565.4 565.4" style="enable-background:new 0 0 565.4 565.4;" xml:space="preserve">
            <path d="M501.5,0H64C28.6,0,0,28.6,0,63.9v437.5c0,35.3,28.6,63.9,64,63.9h437.5c35.3,0,63.9-28.6,63.9-63.9V63.9
                C565.4,28.6,536.8,0,501.5,0z M479.1,189.2L246.8,421.5c-12.4,12.4-32.8,12.4-45.2,0c-1.5-1.5-2.3-3.5-3.4-5.2L86.3,304.4
                c-12.4-12.4-12.4-32.8,0-45.2c12.4-12.4,32.8-12.4,45.2,0l93.5,93.5l208.8-208.8c12.4-12.4,32.8-12.4,45.2,0
                C491.5,156.4,491.5,176.7,479.1,189.2z"/>
        </svg>
    `
})

export class SvgCheckedComponent {

}



// WEBPACK FOOTER //
// /app/src/app/components/svg/checked.component.ts